import { twMerge } from 'tailwind-merge';

export const classes = {
  wrapper:
    'group/tile relative flex w-full h-full min-w-0 min-h-0 gap-2 p-2 overflow-hidden',
  tileFrame:
    'rounded-[18px] border border-solid border-black/10 bg-white/[0.82] shadow-aurora-card dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  fullSidebar: 'relative h-full grow flex flex-col',
  sidebar:
    'relative h-full shrink-0 w-[268px] flex flex-col transition-[width] duration-200 ease-out',
  sidebarWide: 'w-[308px]',
  sidebarOverlayMobile:
    'max-md:absolute max-md:inset-y-2 max-md:left-2 max-md:h-auto max-md:z-20 max-md:rounded-2xl max-md:border max-md:border-black/10 max-md:bg-white/90 max-md:backdrop-blur-md max-md:shadow-aurora-card max-md:dark:border-white/10 max-md:dark:bg-[#332e43]/95',
  sidebarCondensed: 'relative h-full shrink-0 w-[72px] flex flex-col',
  sidebarStrip:
    'h-full shrink-0 w-11 place-end flex-col pb-1 border-r border-black/10 dark:border-white/10 max-md:absolute max-md:bottom-4 max-md:left-4 max-md:z-20 max-md:h-auto max-md:w-auto max-md:border-r-0 max-md:pb-0 max-md:rounded-xl max-md:bg-white/70 max-md:backdrop-blur-sm max-md:dark:bg-[#332e43]/80',
  sidebarHidden: 'hidden',
  menuIconClosed: 'rotate-180',
};

export function getSidebarClass(
  hasActiveFile: boolean,
  compact: boolean,
  isSidebarOpen: boolean,
  wide: boolean
) {
  if (!hasActiveFile) return classes.fullSidebar;
  if (compact) {
    return isSidebarOpen
      ? classes.sidebarCondensed
      : twMerge(classes.sidebarCondensed, classes.sidebarHidden);
  }
  const base = twMerge(
    classes.sidebar,
    classes.sidebarOverlayMobile,
    wide && classes.sidebarWide
  );
  return isSidebarOpen ? base : twMerge(base, classes.sidebarHidden);
}
